import { Button } from 'primereact/button';
import Data from '../../../../components/Display/Data';

function NewsListItem({ news, deleteNews, updateNews }) {
  return (
    <div className="flex flex-row w-full justify-between p-5 rounded-lg shadow mb-5">
      <div className={`w-full mb-4 flex flex-col gap-y-3`}>
        <span className="text-lg font-semibold text-slate-700">{news.title}</span>
        <div className="flex-row flex flex-wrap gap-3">
          <Data key="source_label" label={'Journal'} value={news.source_label} large />
          <Data
            key="date"
            label={'Date'}
            value={new Date(news.publication_date).toLocaleDateString()}
          />
          <Data key="source_url" label={"Lien de l'article"} value={news.source_url} large />
          <Data key="author" label={'Auteur·ice'} value={news.author} />
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          rounded
          icon="pi pi-pencil"
          severity="success"
          onClick={() => updateNews(news)}
          outlined
          size="small"
          className="!h-9 !w-9"
        />
        <Button
          rounded
          icon="pi pi-trash"
          severity="danger"
          onClick={() => deleteNews(news)}
          outlined
          size="small"
          className="!h-9 !w-9"
        />
      </div>
    </div>
  );
}

export default NewsListItem;
